import { render, staticRenderFns } from "./HeroTemporario.vue?vue&type=template&id=230d7464&scoped=true&"
import script from "./HeroTemporario.vue?vue&type=script&lang=js&"
export * from "./HeroTemporario.vue?vue&type=script&lang=js&"
import style0 from "./HeroTemporario.vue?vue&type=style&index=0&id=230d7464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d7464",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
